var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9339AC96-CBE9-4827-A940-4EF01E306AAC@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3137085,3.3137085 C11.8659932,3.3137085 12.3137085,3.76142375 12.3137085,4.3137085 L12.3137085,10.3137085 L18.3137085,10.3137085 C18.8265443,10.3137085 19.2492157,10.6997487 19.3069808,11.1970874 L19.3137085,11.3137085 C19.3137085,11.8659932 18.8659932,12.3137085 18.3137085,12.3137085 L12.3137085,12.3137085 L12.3137085,18.3137085 C12.3137085,18.8265443 11.9276683,19.2492157 11.4303296,19.3069808 L11.3137085,19.3137085 C10.7614237,19.3137085 10.3137085,18.8659932 10.3137085,18.3137085 L10.3137085,12.3137085 L4.3137085,12.3137085 C3.80087266,12.3137085 3.37820134,11.9276683 3.32043623,11.4303296 L3.3137085,11.3137085 C3.3137085,10.7614237 3.76142375,10.3137085 4.3137085,10.3137085 L10.3137085,10.3137085 L10.3137085,4.3137085 C10.3137085,3.80087266 10.6997487,3.37820134 11.1970874,3.32043623 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Biblio_Menu_mobile",
    transform: "translate(-365.000000, -41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(12.757058, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(19.242942, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/user-Copy-8",
    transform: "translate(333.686292, 0.686292)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#182B43",
    transform: "translate(11.313708, 11.313708) rotate(45.000000) translate(-11.313708, -11.313708) ",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.32dca575cf0fee7cee25cd8ad96e9a4b.svg";
export { ForwardRef as ReactComponent };